<template>
  <div id="app">
    <div class="mx-auto main-container col-12 px-0">
      <Header></Header>
      <div id="main-content" class="content-block pb-4">
        <router-view></router-view>
      </div>
      <Footer></Footer>
      <LoginPopUp v-if="!userData"></LoginPopUp>
      <AliveGame v-if="userHasAliveGame"></AliveGame>
      <ModalAlert></ModalAlert>
      <NewMessagesPopUp v-if="newMessages"></NewMessagesPopUp>
      <FlashMessages v-if="flashMessages"></FlashMessages>
      <AfterWithdrawModal></AfterWithdrawModal>
      <FreeRoundSelector v-if="!userHasAliveGame && allowFreeRoundPopup"></FreeRoundSelector>
    </div>
  </div>
</template>

<script>
import Header from './components/main/Header'
import Footer from './components/main/Footer'
import LoginPopUp from './components/user/LoginPopUp'
import AliveGame from './components/games/AliveGame'
import ModalAlert from './components/ModalAlert'
import NewMessagesPopUp from './components/user/NewMessagesPopUp'
import FlashMessages from './components/main/FlashMessages'
import AfterWithdrawModal from "./components/payments/AfterWithdrawModal"
import FreeRoundSelector from "@/components/games/FreeRoundSelector";

export default {
  name: 'App',
  components: {
    FreeRoundSelector,
    Header,
    Footer,
    LoginPopUp,
    AliveGame,
    ModalAlert,
    NewMessagesPopUp,
    FlashMessages,
    AfterWithdrawModal
  },
  data () {
    return {
      currentPath: null,
      allowFreeRoundPopup: false
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    userHasAliveGame () {
      const userData = this.$store.getters.userData
      if (!userData) {
        return false
      }
      const aliveGames = this.$store.getters.aliveGames

      return !!(aliveGames && aliveGames.length)
    },
    newMessages () {
      const userData = this.$store.getters.userData
      if (!userData) {
        return false
      }
      const newMessages = this.$store.getters.newMessages

      return !!(newMessages && newMessages.length)
    },
    flashMessages () {
      const flashMessages = this.$store.getters.getFlashMessages
      return !!(flashMessages && flashMessages.messages && flashMessages.messages.length)
    },
    isGamePage () {
      return this.$route.name === 'LaunchGame' || this.$route.name === 'LaunchLiveGame' || this.$route.name === 'LaunchGameMobile'
    },
    freeRound() {
      return this.$store.getters.freeRound
    },
  },
  methods: {
    scrollTop () {
      window.scrollTo({ top: 0 })
    },
    isMobile () {
      return this.$_config.environment.mobile
    }
  },
  mounted () {
    const header = document.getElementById('header')
    const footer = document.getElementById('footer')
    const content = document.getElementById('main-content')
    if (typeof header !== 'undefined' && typeof footer !== 'undefined' && typeof content !== 'undefined') {
      const contentNeedHeight = window.innerHeight - footer.offsetHeight - header.offsetHeight
      content.style.minHeight = contentNeedHeight + 'px'
    }
    if(!this.isGamePage){
      this.$store.dispatch('checkUserFreeRound')
    }

  },
  watch: {
    $route (to,previousRoute) {
      if (to.name === "LaunchGameMobile") {
        let mainElem = document.getElementById("main-content")
        mainElem.style.height = "100vh"
        mainElem.style.width = "100vw"
        mainElem.style.position = "fixed"
        mainElem.style.top = "0"
        mainElem.style.zIndex = "889"
      }

      let previousRouteName = previousRoute.name

      if (previousRouteName === "LaunchGame" || previousRouteName === "LaunchGameMobile") {
        this.$store.dispatch("checkForAliveGame")
      }
      const collapseBtn = document.getElementById('nav-collapse-button')
      const collapseState = collapseBtn.getAttribute('aria-expanded')
      if (collapseState === 'true') {
        collapseBtn.click()
      }
      document.title = to.meta.title ? to.meta.title+':VipMagnit Казино' : 'VipMagnit Казино'

      setTimeout(() => {
        let chatBlock = document.getElementById('tawkchat-container')
        if (chatBlock) {
          let chatStyles = chatBlock.style.cssText
          if (this.isGamePage && this.isMobile()) {
            chatBlock.style.display = 'none'
          } else {
            chatBlock.style.display = 'block'
            chatBlock.style.cssText = chatStyles + '; z-index:10 !important ;'
          }
        }
      }, 1500)
    },
    alive: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.allowAliveGamePopup = true
        }
      }
    },
    freeRound: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.allowFreeRoundPopup = true
        }
      }
    }
  }
}
</script>
